export const MARITAL_STATUS_OPTIONS = [
  { value: null, text: "select marital Status" },
  { value: 1, text: "Married" },
  { value: 2, text: "Single" },
  { value: 3, text: "Divorced" },
];

export function maritalStatusLabel(value) {
  if (value === null || value === undefined || value === "") {
    return "-";
  }
  const numeric = parseInt(value, 10);
  if (numeric === 1 || value === "Married") {
    return "Married";
  }
  if (numeric === 2 || value === "Not Married" || value === "Single") {
    return "Single";
  }
  if (numeric === 3 || value === "Divorced") {
    return "Divorced";
  }
  return String(value);
}
